module.exports = __webpack_public_path__ + "img/master-title.a52b351d.png";